import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function SearchContent(props = {}, childrenComponents = [], blocks = []) {
	return {
		componentName: 'SearchContent',
		componentId: uuidv4(),
		draggableType: 'Container',
		droppableType: 'NONE',
		props: _.merge(
			{
				mzShowNotFound: false,
			},
			props,
		),
		childrenComponents: [],
		blocks,
	};
}
